export default "__VITE_ASSET__DaI9JTzt__"